





































































































































































































































































































































import Vue from 'vue'

import Process from '@/components/workflow/Process.vue'
import Task from '@/components/workflow/Task'
import Timer from '@/components/workflow/Timer'

export default Vue.extend({
  computed: {
    currentCase(): any {
      return this.$store.getters.currentCase
    },
  },
  components: { Process, Task, Timer },
})
